<template>
  <div class="export-button-container relative">
    <button
      class="flex items-center gap-2 bg-secondary-800 text-ellipsis text-white text-base rounded px-4 py-2 hover:-translate-y-1 transition-all duration-300"
      @click="toggleDatepicker"
    >
      <span>{{
        data === null ? props.buttonText : `${data.from_date} - ${data.to_date}`
      }}</span>
      <CloseIcon v-if="data" :size="15" @click="removeSelectDate" />
    </button>
    <div class="datepicker-wrapper absolute top-full end-2 mt-1 z-10">
      <vue-tailwind-datepicker
        v-if="showDatepicker"
        v-model="dateValue"
        overlay
        separator=" - "
        :no-input="true"
        :formatter="formatter"
        :auto-apply="false"
        :shortcuts="false"
        dir="ltr"
        @update:model-value="handleDateUpdate"
        @closed="showDatepicker = false"
      />
    </div>
    <div
      v-if="showDatepicker"
      class="fixed inset-0"
      @click="toggleDatepicker"
    ></div>
  </div>
</template>

<script lang="ts" setup>
// Import Vue Packages
import { ref } from 'vue'
import { X as CloseIcon } from 'lucide-vue-next'

// Import Vue Custom Components
import VueTailwindDatepicker from 'vue-tailwind-datepicker'

// Import Vue Components
import { MONTHS_NAMES } from 'src/constants'

// Variables
const emit = defineEmits(['exportRange'])
const props = defineProps({
  buttonText: {
    type: String,
    default: 'Export',
  },
  pageLang: {
    type: String,
    default: 'ar'
  },
  pageDir: {
    type: String,
    default: 'rtl'
  },
})
const dateValue: any = ref([])
const showDatepicker = ref<boolean>(false)
const formatter = ref({
  date: 'MMMM DD, YYYY',
  month: 'MMM',
})
const data = ref<null | any>(null)

// Fuctions
const handleDateUpdate = async (from_to_dates: any) => {
  if (from_to_dates.length != 2) {
    return
  }

  const [from_month, from_day, from_year] = from_to_dates[0].split(' ')
  const [to_month, to_day, to_year] = from_to_dates[1].split(' ')

  showDatepicker.value = false

  data.value = {
    from_date: `${from_year}-${MONTHS_NAMES[from_month]}-${from_day.split(',')[0]}`,
    to_date: `${to_year}-${MONTHS_NAMES[to_month]}-${to_day.split(',')[0]}`,
  }

  emit('exportRange', data.value)
}

const toggleDatepicker = () => (showDatepicker.value = !showDatepicker.value)
const removeSelectDate = () => {
  data.value = null
  dateValue.value = []
}
</script>
